import React,{useState, useEffect} from 'react'
import {Button,TextField,FormControl,InputLabel,OutlinedInput,MenuItem,Select,
    FormHelperText,Modal,FormControlLabel,Checkbox,Table,TableHead,TableRow,TableCell,TableBody} from '@material-ui/core'
import { MuiThemeProvider, createMuiTheme,withStyles,makeStyles } from '@material-ui/core/styles'
import Select1 from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import Close from 'assets/icon/close.svg'
import Edit from 'assets/icon/edit.png'
import {addOwner} from 'redux/actions/pipeline'
import {modalToggleReset} from 'redux/actions/general'
import AutoCompleteSelect from 'components/Select'

const themeField = createMuiTheme({  
    palette: {  
        primary: {
            main:'#70bf4e',
            contrastText: '#FFFFFF',

        },
        secondary:{
            main:'#3B99EB',
            contrastText: '#FFFFFF',

        }
    } 
})
const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main:'#70bf4e',
        },
        secondary:{
            main:'#ffb100',
            contrastText: '#FFFFFF',

        }
    } 
})
const useStyles = makeStyles(theme => ({
    textField: {
      [`& fieldset`]: {
        borderRadius: 10,
      },
      width:'100%',
      marginBottom:15
  },
    textField2: {
      [`& fieldset`]: {
        borderRadius: 10,
      },
      width:'100%',
    //   marginBottom:15
  }
  
}));
const AddRmModal=({modal_open,modalToggle,setState,state})=>{
    const classes=useStyles()
    const [rm, setRm] = useState({
        userId:null,
        percent:null,
        full_user:null
    })
    const master=useSelector(state=>state.master)

    useEffect(()=>{
        console.log('ahihihi',rm,state.modal_data)
        if(modal_open&&state.modal_data!==null){
            console.log('hello', modal_open,state.modal_data)
            setRm({
                ...rm,
                percent:state.modal_data.percent,
                userId:{label:state.modal_data.full_user.name,value:state.modal_data.full_user.userId},
                full_user:state.modal_data.full_user
            })
        }else{
            console.log('hiks', modal_open,state.modal_data)
    
            setRm({
                ...rm,
                percent:null,
                full_user:null,
                userId:null
            })
        }
    },[state])
    const renderDisable=()=>{
        if(rm.full_user!==null){
            // alert('hello')
            return false
        }else{
            return true
        }
    }
    const onChangeSelect=(data)=>{
        if(data!==null){
            let s=filterRm(data.value)
            setRm({
                ...rm,
                userId:data,
                full_user:{userId:s[0].userId,email:s[0].email,name:s[0].name}
            })
        }
        
        
        // console.log('hello  ', data)
    }
    const filterRm=(id)=>{
        let m=master.rm_full.filter((data)=>{
            return data.userId===id
        })
        return m
    }
    const onClickSave=()=>{
        if(state.modal_data!==null){
            state.rms.splice(state.modal_data.index, 1);
            state.rms.splice(state.modal_data.index, 0, rm);
            modalToggle()

        }else{
            console.log('asdf', rm)
            setState({
                ...state,
                rms:[...state.rms,rm]
            })
        //    setRm({
        //        ...rm,
        //        percent:null,
        //        full_user:null,
        //        userId:null
        //    })
            modalToggle()
        }
        
    }
    console.log('rm.userId', rm)
    return(
        <Modal
            className='modal'
            open={modal_open}
            onClose={modalToggle}
        >
            <div className='modal-content' style={{width:400}}>
                <div className='modal-body' >
                    <MuiThemeProvider theme={themeField}>
                        <AutoCompleteSelect
                            // multiple
                            onChange={(event,value)=>onChangeSelect(value)}
                            options={master.rm}
                            getOptionLabel={(option) => option.label}
                            label={<>Name</>}
                            value={rm.userId}

                        />
                        
                        <TextField
                            label='Percentage'
                            type='text'
                            value={rm.percent}
                            onChange={(e)=>setRm({...rm,percent:e.target.value})}
                            variant='outlined'
                            size='small'
                            className={classes.textField}

                        />
                    </MuiThemeProvider>
                    <MuiThemeProvider theme={themeButton}>
                        <div className='modal-footer'>
                            <Button disabled={renderDisable()} onClick={onClickSave}  size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded' style={{width:120,height:30}}>Save</Button>
                        </div>
                    </MuiThemeProvider>
                </div>

            </div>
        </Modal>
    )
}
const AddTribeModal=({modal_open_tribe,modalToggleTribe,setState,state})=>{
    const classes=useStyles()
    const [tribe, setTribe] = useState({
        percent:null,
        tribeId:null
    })
    const master=useSelector(state=>state.master)

    useEffect(()=>{
        // console.log('ahihihi',tribe)

        if(modal_open_tribe&&state.modal_data!==null){
            setTribe({
                ...tribe,
                percent:state.modal_data.percent,
                tribeId:state.modal_data.tribeId
            })
        }else{
    
            setTribe({
                ...tribe,
                percent:null,
                tribeId:null
            })
        }
    },[state])
    
   
    
    const onClickSave=()=>{
        if(state.modal_data!==null){
            state.tribes.splice(state.modal_data.index, 1);
            state.tribes.splice(state.modal_data.index, 0, tribe);
            modalToggleTribe()
            console.log('tribe', tribe)
        }else{
            console.log('tribe', tribe)
            setState({
                ...state,
                tribes:[...state.tribes,tribe]
            })
            // setState({
            //     ...state,
            //     rms:[...state.rms,rm]
            // })
            modalToggleTribe()
        }
        
    }
    // console.log('tribe.tribeId', tribe.tribeId)
    const renderDisable=()=>{
        if(tribe.tribeId!==null){
            // alert('hello')
            return false
        }else{
            return true
        }
    }
    return(
        <Modal
            className='modal'
            open={modal_open_tribe}
            onClose={modalToggleTribe}
        >
            <div className='modal-content' style={{width:400}}>
                <div className='modal-body' >
                    <br/>
                    <MuiThemeProvider theme={themeField}>
                         <AutoCompleteSelect
                            // multiple
                            onChange={(event,value)=>setTribe({...tribe,tribeId:value})}
                            options={master.tribes}
                            getOptionLabel={(option) => option.text}
                            label={<>Tribe</>}
                            value={tribe.tribeId}

                        />
                        
                        <TextField
                            label='Percentage'
                            type='text'
                            value={tribe.percent}
                            onChange={(e)=>setTribe({...tribe,percent:e.target.value})}
                            variant='outlined'
                            size='small'
                            className={classes.textField}

                        />
                    </MuiThemeProvider>
                    <MuiThemeProvider theme={themeButton}>
                        <div className='modal-footer'>
                            <Button disabled={renderDisable()} onClick={onClickSave}  size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded' style={{width:120,height:30}}>Save</Button>
                        </div>
                    </MuiThemeProvider>
                </div>

            </div>
        </Modal>
    )
}
export default function Owner(props) {
    const classes=useStyles()
    const [modal_open,setModalOpen]=useState(false)
    const [modal_open_tribe,setModalOpenTribe]=useState(false)
    const dispatch=useDispatch()
    const [state, setState] = useState({
        tribes:[],
        segmentId:0,
        branchId:0,
        consultans:[],
        rms:[],
        modal_data:null
    })
    useEffect(()=>{
        if(props.modal_data!==null){
            let new_consultants=[]
            let new_tribe=[]
            props.modal_data.consultants.map((data)=>{
                new_consultants.push({label:data.text,value:data.id})
            })
            props.modal_data.tribe.map((data)=>{
                new_tribe.push({tribeId:{id:data.id,text:data.text},percent:data.percent})
            })
            setState({
                ...state,
                tribes:new_tribe,
                segmentId:props.modal_data.segment.id,
                branchId:props.modal_data.branch.id,
                consultans:new_consultants,
                rms:props.modal_data.rms,

            })
            console.log('props.modal_data', props.modal_data)
        }
    },[])
    const master=useSelector(state=>state.master)
    const modalToggle=()=>{
        setModalOpen(!modal_open)
    }
    const modalToggleTribe=()=>{
        setModalOpenTribe(!modal_open_tribe)
    }
    const addRm=()=>{
        setState({
            ...state,
            modal_data:null
        })
        modalToggle()
    }
    const editRm=(data)=>{
        setState({
            ...state,
            modal_data:data
        })
        modalToggle()
    }
    const deleteRm=(data)=>{
        state.rms.splice(data, 1);
        setState({
            ...state,
            rms:state.rms
        })
    }
    const addTribe=()=>{
        setState({
            ...state,
            modal_data:null
        })
        modalToggleTribe()
    }
    const editTribe=(data)=>{
        setState({
            ...state,
            modal_data:data
        })
        modalToggleTribe()
    }
    const deleteTribe=(data)=>{
        state.tribes.splice(data, 1);
        setState({
            ...state,
            tribes:state.tribes
        })
    }
    const onChange=(e)=>{
        let {name,value}=e.target
        setState({
            ...state,
            [name]:value
        })
    }
    const onClickSave=()=>{
        let new_consultants=[]
        let new_rms=[]
        let new_tribes=[]
        state.consultans.map((data)=>{
            new_consultants.push(data.value)
        })
        state.rms.map((data)=>{
            new_rms.push({userId:data.full_user.userId,percent:parseInt(data.percent)})
        })
        state.tribes.map((data)=>{
            new_tribes.push({tribeId:data.tribeId.id,percent:parseInt(data.percent)})
        })
        let data={
            dealId:props.modal_data.dealId,
            userId:props.profile.id,
            segmentId:state.segmentId,
            branchId:state.branchId,
            consultants:new_consultants,
            rms:new_rms,
            tribes:new_tribes
        }
        console.log('data', data)
        dispatch(addOwner(props.token,data))
        // dispatch(modalToggleReset())
    }
    // console.log('state', state)
    return (
        <div>
            <AddRmModal setState={setState} state={state} modal_open={modal_open} modalToggle={modalToggle}/>
            <AddTribeModal setState={setState} state={state} modal_open_tribe={modal_open_tribe} modalToggleTribe={modalToggleTribe}/>
            <MuiThemeProvider theme={themeField}>
            <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p className='semi-bold'>Tribe</p>
                    <Button onClick={addTribe} className='remove-capital' color='secondary' variant='text' size='small'>Add Tribe</Button>
                </div>
                <Table  size="small" aria-label="a dense table" style={{color:'#777777'}}>
                    <TableHead>
                    <TableRow >
                        <TableCell className='card-content-item-jurnal-text'>Tribe name</TableCell>
                        <TableCell align='center' className='card-content-item-jurnal-text'>Percentage for this deal</TableCell>
                        <TableCell align='right' className='card-content-item-jurnal-text'>Action</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {state.tribes.length>0?state.tribes.map((data,i)=>(
                            <TableRow >
                                <TableCell align='left'  className='card-content-item-jurnal-text-without-weight'>{data.tribeId.text}</TableCell>
                                <TableCell align='center' className='card-content-item-jurnal-text-without-weight'>{data.percent}</TableCell>
                                <TableCell align='center' className='card-content-item-jurnal-text-without-weight'>
                                    <img src={Edit} onClick={()=>editTribe({...data,index:i})} className='icon-action'/>
                                    <img src={Close} onClick={()=>deleteTribe(i)} className='icon-action'/>
                                </TableCell>
                            </TableRow>
                        ))
                        :
                        <TableRow >
                            <TableCell  style={{textAlign:'center'}} colSpan={4} >No tribe</TableCell>
                        </TableRow>
                        }
                   
                    </TableBody>
                </Table>
                <br/>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                    <p className='semi-bold'>Relationship Manager</p>
                    <Button onClick={addRm} className='remove-capital' color='secondary' variant='text' size='small'>Add RM</Button>
                </div>
                <Table  size="small" aria-label="a dense table" style={{color:'#777777'}}>
                    <TableHead>
                    <TableRow >
                        <TableCell className='card-content-item-jurnal-text' style={{width:215}}>Name</TableCell>
                        <TableCell className='card-content-item-jurnal-text'>Percentage for this deal</TableCell>
                        <TableCell align='right' className='card-content-item-jurnal-text'>Action</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {state.rms.length>0?state.rms.map((data,i)=>(
                            <TableRow >
                                <TableCell align='left'  className='card-content-item-jurnal-text-without-weight'>{data.full_user.name}</TableCell>
                                <TableCell align='center' className='card-content-item-jurnal-text-without-weight'>{data.percent}</TableCell>
                                <TableCell align='center' className='card-content-item-jurnal-text-without-weight'>
                                    <img src={Edit} onClick={()=>editRm({...data,index:i})} className='icon-action'/>
                                    <img src={Close} onClick={()=>deleteRm(i)} className='icon-action'/>
                                </TableCell>
                            </TableRow>
                        ))
                        :
                        <TableRow >
                            <TableCell  style={{textAlign:'center'}} colSpan={4} >No relationship manager</TableCell>
                        </TableRow>
                        }
                   
                    </TableBody>
                </Table>
                <br/>
                
                <div style={{display:'flex',marginTop:10}}>
                    <FormControl variant="outlined" size="small" className='add-proposal__field' >
                        <InputLabel  htmlFor="category">Segment</InputLabel>
                        <Select name='segmentId' value={state.segmentId}  onChange={onChange} labelId="label" id="select"  labelWidth={65} className='field-radius'>
                            {master.segments.map((data,i)=>(
                                <MenuItem value={data.id}>{data.text}</MenuItem>
                            ))}
                            
                        </Select>
                    </FormControl>
                    &nbsp;&nbsp;
                    <FormControl variant="outlined" size="small" className='add-proposal__field' >
                        <InputLabel  htmlFor="category">Branch</InputLabel>
                        <Select name='branchId' value={state.branchId}  onChange={onChange} labelId="label" id="select"  labelWidth={65} className='field-radius'>
                            {master.branches.map((data,i)=>(
                                <MenuItem value={data.id}>{data.text}</MenuItem>
                            ))}
                            
                        </Select>
                    </FormControl>
                </div>
                <AutoCompleteSelect
                    multiple
                    onChange={(event,value)=>setState({...state,consultans:value})}
                    options={master.employee}
                    getOptionLabel={(option) => option.label}
                    label={<>Consultant</>}
                    value={state.consultans}

                /> 
                
                
            </MuiThemeProvider>
            <MuiThemeProvider theme={themeButton}>
                <div className='modal-footer'>
                    <Button onClick={onClickSave}  size='small' color='secondary' variant='contained' className='btn-remove-capital btn-rounded' style={{width:120,height:30}}>Save</Button>
                </div>
            </MuiThemeProvider>
        </div>
    )
}
